import React, { memo } from 'react';

import PropTypes from 'prop-types';

import ExternalFulfillmentDisplayProvider from './external/external-fulfillment-display-provider';
import ManualFulfillmentDisplayContextProvider from './manual/manual-fulfillment-display-provider';
import FulfillmentDisplayProvider from './shipped/fulfillment-display-provider';
import { FulfillmentPlanFulfillmentType } from '../../../../../enums/fulfillment-plan-fulfillment-type';
import { ExternalFulfillmentDisplayContent } from '../../../fulfillment/external-fulfillment-display/content';
import ManualFulfillmentDisplayContent from '../../../fulfillment/manual-fulfillment-display/content';
import ShipmentDisplayContent from '../../../fulfillment/shipment-display/content';

const FulfillmentDisplayContent = ({ fulfillmentPlanId, fulfillmentId, fulfillmentType }) => {
  if (fulfillmentType === FulfillmentPlanFulfillmentType.Shipment) {
    return (
      <FulfillmentDisplayProvider fulfillmentId={fulfillmentId} fulfillmentPlanId={fulfillmentPlanId}>
        <ShipmentDisplayContent />
      </FulfillmentDisplayProvider>
    );
  }

  if (fulfillmentType === FulfillmentPlanFulfillmentType.External) {
    return (
      <ExternalFulfillmentDisplayProvider fulfillmentId={fulfillmentId} fulfillmentPlanId={fulfillmentPlanId}>
        <ExternalFulfillmentDisplayContent />
      </ExternalFulfillmentDisplayProvider>
    );
  }

  if (fulfillmentType === FulfillmentPlanFulfillmentType.Manual) {
    return (
      <ManualFulfillmentDisplayContextProvider fulfillmentId={fulfillmentId}>
        <ManualFulfillmentDisplayContent />
      </ManualFulfillmentDisplayContextProvider>
    );
  }
};

export default memo(FulfillmentDisplayContent);

FulfillmentDisplayContent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fulfillmentId: PropTypes.string.isRequired,
  fulfillmentType: PropTypes.string.isRequired,
};
